import { PureComponent, ReactNode } from 'react';
import { connect } from 'react-redux';
import { LAB_VITAL_TESTS } from '../../../../labTestsConstants';
import LabTestsPadV2 from '../../../../pages/LabTestsPadV2';
import { Data } from '../../../../store/types/LabTests';
import { LabVital } from '../../../common/Icons';
import PadV2LabVitalTable from './LabVitalTable';
import { LabVitalOnPadAutoSuggest } from './padV2/LabVitalAutoSuggest';
import PadV2PxElementCard from './padV2/PadV2PxElementCard';
import TemplateIcons from './padV2/TemplateIcons';
import LabVitalCardHeaderActions from './LabVitalCardHeaderActions';

type Props = {
    onContainerClick: () => void;
    sectionName?: string;
};

const LabVitalIcon = LabVital();

class LabVitalV2 extends PureComponent<Props> {
    render(): ReactNode {
        const { onContainerClick, sectionName } = this.props;

        return (
            <div key="labVitals" id="labVitals" onFocus={onContainerClick}>
                <PadV2PxElementCard
                    icon={LabVitalIcon}
                    headingText={sectionName || 'Lab Results'}
                    iconContainerBgClassName="bg-darwin-accent-bright-yellow-900"
                    bodyCssClassName="space-y-8 rounded-8"
                    renderHeaderRight={() => (
                        <div className="flex mt-8 mr-16">
                            <LabTestsPadV2 data={LAB_VITAL_TESTS as Data[]} />
                            <LabVitalCardHeaderActions />
                            <div className="flex items-center space-x-16 ml-16">
                                <TemplateIcons
                                    pxToolKey={'labVitals'}
                                    isModal={false}
                                    withPeak={true}
                                />
                            </div>
                        </div>
                    )}
                >
                    <PadV2LabVitalTable />
                    <LabVitalOnPadAutoSuggest />
                </PadV2PxElementCard>
            </div>
        );
    }
}

export default connect()(LabVitalV2);
